import React, { useState } from "react";
import CrmEmpty from "../CrmEmpty";
import { Table, Spin, Space, Button } from "antd";
import { FileAddOutlined } from "@ant-design/icons";
import moment from 'moment-jalaali';
import strings from '../../../../utils/strings';
import { useReportsStore } from "../../../../store/slices/createReportsSlice";
import { useGeneralStore } from "../../../../store/slices/createGeneralSlice";
import EndorsementInfo from "../../../issue-endorsement-report/EndorsementInfo";

export default function CrmEndorsementTable() {

  const reports = useReportsStore()
  const general = useGeneralStore();
  const data = reports.crmEndorsements.data.Endorsements;
  const loading = reports.crmEndorsements.loading;
  const [endorsementId, setEndorsementId] = useState();

  const columns = [
    {
      title: "جزئیات الحاقیه",
      dataIndex: "endorsementOperation",
      key: "endorsementOperation",
      width: 40,
      render: (_, record) =>
        data.length >= 1 && (
          <Space size="middle">
            <Button type='link' onClick={() => {
              reports.getEndorsementDetailsInfo(record.EndorsementId)
              setEndorsementId(record.EndorsementId);
              general.ToggleEndorsementDetailsModal();
            }
            }><FileAddOutlined /></Button>
          </Space>
        ),
    },
    {
      title: 'نوع الحاقیه',
      dataIndex: 'TypeTitle',
      width: 100,
      key: 'TypeTitle',
      render: text => strings.getFarsiNum(text),
    },


    {
      title: "وضعیت",
      dataIndex: "StatusTitle",
      key: "StatusTitle",
      width: 100,
    },
    {
      title: "مبلغ",
      dataIndex: "Amount",
      key: "Amount",
      width: 110,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },

    {
      title: 'تاریخ ثبت',
      dataIndex: 'CreationTime',
      key: 'CreationTime',
      width: 100,
      render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD  ساعت:  HH:mm  '))
    },
  ];

  return (
    <Spin spinning={loading} >
      {data && data.length > 0 ?
        <Table
          style={{ overflowX: 'scroll' }}
          size="small"
          className="custom-table crm-request-report"
          bordered
          loading={loading}
          rowKey="Id"
          scroll={true}
          dataSource={data}
          columns={columns}

        />
        :
        <CrmEmpty text="الحاقیه یافت نشد" />}
      <EndorsementInfo endorsementId={endorsementId} />
    </Spin>
  );
}
